import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthService } from '../services/auth.service';
import { UserStore } from '../stores/user.store';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private userStore = inject(UserStore);
  private authService = inject(AuthService);

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return next
      .handle(req)
      .pipe(catchError((err: HttpErrorResponse) => this.handleErrors(err)));
  }

  handleErrors(res: HttpErrorResponse) {
    const defaultErrorMessage = {
      message:
        'Pri obdelavi vaše zahteve je prišlo do težave. Prosimo poskusite znova.',
    };

    // client-side error (Network problems and front-end code errors)
    if (res.error instanceof ErrorEvent) {
      return throwError(() =>
        res.error.error.message ? res.error.error : defaultErrorMessage,
      );
    }

    // 401 unauthorized
    if (res.status === 401) {
      // todo - redirect only if not on auth/ pages
      this.authService.logout(true);
    }

    if (res.status === 500) {
      return throwError(() => defaultErrorMessage);
    }

    return throwError(() =>
      res.error.error.message ? res.error.error : defaultErrorMessage,
    );
  }
}
